jQuery ->
  $('#new_contact_form').validate
    submitHandler: (form) ->
      fbq('track', 'Contact')
      form.submit()
